module.exports = __webpack_public_path__ + "img/working-hours.a8328efe.png";